import React from 'react';
import { RouteObject } from 'react-router-dom';
import { FaServer, FaTicketAlt, FaHeadset, FaFileInvoiceDollar, FaHospital, FaCubes } from 'react-icons/fa';

// Lazy load components
import { lazy } from 'react';

// Import pages
import {
  Patients,
  WaitingList,
  WaitingRoom,
  ProcedureTypes,
  ProcedureTypeCategories,
  BookedProcedures,
  AppointmentTypes,
  AddEditAppointmentMockup,
  OpioidCalculator,
  Facilities,
  FacilityDetails,
  FacilitiesRoomTypes,
  FacilityProviders,
  FacilitiesRooms,
  FacilityTypes,
  ProviderTypes,
  SessionRosterEditor,
  SessionRosters,
  SessionTypes,
  StaffRostering,
  Documents,
  Users,
  Groups,
  AddressBook,
  AddressBookReferrers,
  ReferrerDetails,
  Letters,
  CreateLetter,
  GenerateLetter,
  AIIntegrationHub,
  AIAssistant,
  Dictations,
  DictationTypes,
  EmailList,
  ComposeEmail,
  EmailTemplates,
  EmailTemplateEditor,
  Signatures,
  OperationReportTemplates,
  OperationReportGenerator,
  PainChart,
  PainCharts,
  PBSImport,
  CreateBodyPainPointChart,
  CreateOperationReport,
  NewDocument,
  DocumentTypes,
  DocumentCategories,
  DocumentTemplates,
  TemplateEditor,
  PainWorkupSheet,
  StandardWorkupSheet,
  RequestsTracker,
  NLMDrugLookup,
  PublicationSearch,
  Rosters,
  ClinicianDashboard,
  AppointmentsDashboard,
  BillingDashboard,
  InvoiceView,
  InvoiceList,
  InvoiceCreate,
  EclipseClaimStatus,
  BillingTemplates,
  MBSItems,
  MBSItemUpload,
  HealthFundScheduleUpload,
  FeeScheduleViewer,
  TaskList,
  TaskCreate,
  ClientSettings,
  AdminDashboard,
} from '../pages';

import FullscreenChat from '../pages/FullscreenChat';
import Patient from '../components/patients/Patient';
import OldPatientPage from '../pages/Patients/OLDPatient';
import NewPatient from '../pages/Patients/NewPatient';
import CurrentConsult from '../pages/Consult/CurrentConsult';
import ChartOfAccounts from '../pages/Accounts/ChartOfAccounts';
import JournalEntries from '../pages/Accounts/JournalEntries';
import AdminSectionPage from '../admin/pages/AdminSectionPage';
import ClientUsersAdmin from '../admin/pages/ClientUsersAdmin';
import ClientRolesAdmin from '../admin/pages/ClientRolesAdmin';
import ClientFacilitiesAdmin from '../admin/pages/ClientFacilitiesAdmin';
import Preferences from '../pages/Account/Preferences';

export const appRoutes: RouteObject[] = [
  // Default route
  {
    index: true,
    element: <AppointmentsDashboard />
  },
  
  // Fullscreen Chat
  {
    path: "chat",
    element: <FullscreenChat />
  },

  // Account
  {
    path: "preferences",
    element: <Preferences />
  },
  
  // Dashboards
  {
    path: "dashboards/clinician",
    element: <ClinicianDashboard />
  },
  {
    path: "dashboards/billing",
    element: <BillingDashboard />
  },
  
  // Consult
  {
    path: "consult/:appointmentId",
    element: <CurrentConsult />
  },
  
  // Patients
  {
    path: "patients",
    element: <Patients />
  },
  {
    path: "patients/new",
    element: <NewPatient />
  },
  {
    path: "patients/edit/:id",
    element: <Patient />
  },
  {
    path: "patients/:id",
    element: <Patient />
  },
  {
    path: "patients/old/:id",
    element: <OldPatientPage />
  },

  // Facilities
  {
    path: "facilities/facilities",
    element: <Facilities />
  },
  {
    path: "facilities/facilitytypes",
    element: <FacilityTypes />
  },
  {
    path: "facilities/facilitydetails/:id",
    element: <FacilityDetails />
  },
  {
    path: "facilities/facilityroomtypes",
    element: <FacilitiesRoomTypes />
  },
  {
    path: "facilities/facilityrooms",
    element: <FacilitiesRooms />
  },
  {
    path: "facilities/providers",
    element: <FacilityProviders />
  },
  {
    path: "facilities/sessions/sessionrosters",
    element: <SessionRosters />
  },
  {
    path: "facilities/sessions/sessionrostering",
    element: <SessionRosterEditor />
  },
  {
    path: "facilities/sessions/rostereditor",
    element: <SessionRosterEditor />
  },
  
  // Providers
  {
    path: "providers/providertypes",
    element: <ProviderTypes />
  },
  
  // Scheduling
  {
    path: "scheduling/appointments",
    element: <AppointmentsDashboard />
  },
  {
    path: "scheduling/add-edit-appointment-mockup",
    element: <AddEditAppointmentMockup />
  },
  {
    path: "scheduling/waitinglist",
    element: <WaitingList />
  },
  {
    path: "scheduling/waitingroom",
    element: <WaitingRoom />
  },
  {
    path: "scheduling/appointmenttypes",
    element: <AppointmentTypes />
  },
  {
    path: "scheduling/bookedprocedures",
    element: <BookedProcedures />
  },
  {
    path: "scheduling/sessionrosters",
    element: <SessionRosters />
  },
  
  // Procedures
  {
    path: "procedures/proceduretypes",
    element: <ProcedureTypes />
  },
  {
    path: "procedures/proceduretypecategories",
    element: <ProcedureTypeCategories />
  },

  // Admin
  {
    path: "admin",
    element: <AdminDashboard />
  },
  {
    path: "admin/clients",
    element: <ClientSettings />
  },
  {
    path: "admin/servers",
    element: <AdminSectionPage icon={<FaServer className="text-primary" />} title="Servers" description="Monitoring of Docker images, services, and host performance." />
  },
  {
    path: "admin/tickets",
    element: <AdminSectionPage icon={<FaTicketAlt className="text-primary" />} title="Tickets" description="Support tickets submitted by users across clients." />
  },
  {
    path: "admin/remote-support",
    element: <AdminSectionPage icon={<FaHeadset className="text-primary" />} title="Remote Support" description="Generate and manage support session codes for assisted screenshare sessions." />
  },
  {
    path: "admin/subscriptions",
    element: <AdminSectionPage icon={<FaFileInvoiceDollar className="text-primary" />} title="Subscriptions" description="Manage subscription plans and billing entitlements per client." />
  },
  {
    path: "admin/roles",
    element: <ClientRolesAdmin />
  },
  {
    path: "admin/clients/users",
    element: <ClientUsersAdmin />
  },
  {
    path: "admin/clients/facilities",
    element: <ClientFacilitiesAdmin />
  },
  {
    path: "admin/clients/facilities/modules",
    element: <AdminSectionPage icon={<FaCubes className="text-primary" />} title="Modules" description="Fine-tune module access by facility within each client." />
  },
  
  // Clinical Assessment
  {
    path: "clinicalassessment/painworkupsheet",
    element: <PainWorkupSheet />
  },
  {
    path: "clinicalassessment/standardworkupsheet",
    element: <StandardWorkupSheet />
  },
  
  // Clinical Outcomes
  {
    path: "clinicaloutcomes/painchart",
    element: <PainChart />
  },
  {
    path: "clinicaloutcomes/paincharts",
    element: <PainCharts />
  },
  
  // Clinical Reporting
  {
    path: "clinicalreporting/createoperationreport",
    element: <CreateOperationReport />
  },
  {
    path: "operationreports/operationreportgenerator",
    element: <OperationReportGenerator />
  },
  {
    path: "operationreports/operationreporttemplates",
    element: <OperationReportTemplates />
  },
  
  // Body Diagrams
  {
    path: "bodydiagrams/createbodypainpointchart",
    element: <CreateBodyPainPointChart />
  },
  
  // Documents
  {
    path: "documents",
    element: <Documents />
  },
  {
    path: "documents/new",
    element: <NewDocument />
  },
  {
    path: "documents/edit/:id",
    element: <NewDocument />
  },
  {
    path: "documents/documenttypes",
    element: <DocumentTypes />
  },
  {
    path: "documents/documentcategories",
    element: <DocumentCategories />
  },
  {
    path: "documents/templates",
    element: <DocumentTemplates />
  },
  {
    path: "documents/templates/editor",
    element: <TemplateEditor />
  },

  // Email
  {
    path: "email",
    element: <EmailList />
  },
  {
    path: "email/compose",
    element: <ComposeEmail />
  },
  {
    path: "email/templates",
    element: <EmailTemplates />
  },
  {
    path: "email/templates/editor",
    element: <EmailTemplateEditor />
  },
  {
    path: "signatures",
    element: <Signatures />
  },
  
  // Tasks
  {
    path: "tasks",
    element: <TaskList />
  },
  {
    path: "tasks/new",
    element: <TaskCreate />
  },
  {
    path: "tasks/edit/:id",
    element: <TaskCreate />
  },
  
  // Letters
  {
    path: "Letters",
    element: <Letters />
  },
  {
    path: "letters/dictations",
    element: <Dictations />
  },
  {
    path: "letters/dictation-types",
    element: <DictationTypes />
  },
  {
    path: "letters/generate",
    element: <GenerateLetter />
  },
  {
    path: "ai/integration",
    element: <AIIntegrationHub />
  },
  {
    path: "ai/assistant",
    element: <AIAssistant />
  },
  {
    path: "documents/createletter",
    element: <CreateLetter />
  },
  
  // Address Book
  {
    path: "addressbook",
    element: <AddressBook />
  },
  {
    path: "address-book/referrers",
    element: <AddressBookReferrers />
  },
  {
    path: "address-book/referrer/:id",
    element: <ReferrerDetails />
  },

  // Publications
  {
    path: "publications/search",
    element: <PublicationSearch />
  },
  // Rostering
  {
    path: "rostering/rosters",
    element: <Rosters />
  },
  {
    path: "staffrostering",
    element: <StaffRostering />
  },
  {
    path: "sessionrosters",
    element: <SessionRosters />
  },
  
  // Sessions
  {
    path: "sessions/sessiontypes",
    element: <SessionTypes />
  },
  
  // Tools
  {
    path: "tools/opioidcalculator",
    element: <OpioidCalculator />
  },
  {
    path: "tools/requeststracker",
    element: <RequestsTracker />
  },
  
  // Medication
  {
    path: "medication/nlmsearch",
    element: <NLMDrugLookup />
  },
  
  // Import
  {
    path: "import/pbs",
    element: <PBSImport />
  },
  
  // Security
  {
    path: "security/groups",
    element: <Groups />
  },
  {
    path: "security/users",
    element: <Users />
  },

  // Clients
  {
    path: "clients/settings",
    element: <ClientSettings />
  },
  
  // Billing
  {
    path: "billing/invoices",
    element: <InvoiceList />
  },
  {
    path: "billing/invoices/new",
    element: <InvoiceCreate />
  },
  {
    path: "billing/invoices/:id",
    element: <InvoiceView />
  },
  {
    path: "billing/invoices/edit/:id",
    element: <InvoiceView />
  },
  {
    path: "billing/eclipse-claims",
    element: <EclipseClaimStatus />
  },
  {
    path: "billing/templates",
    element: <BillingTemplates />
  },
  {
    path: "billing/mbs-items",
    element: <MBSItems />
  },
  {
    path: "billing/mbs-items/upload",
    element: <MBSItemUpload />
  },
  {
    path: "billing/mbs-items/new",
    element: <MBSItems />
  },
  {
    path: "billing/mbs-items/:id",
    element: <MBSItems />
  },
  {
    path: "billing/fee-schedules",
    element: <FeeScheduleViewer />
  },
  {
    path: "billing/fee-schedules/upload",
    element: <HealthFundScheduleUpload />
  },

  // Accounting/General Ledger
  {
    path: "accounts/chart-of-accounts",
    element: <ChartOfAccounts />
  },
  {
    path: "accounts/journal-entries",
    element: <JournalEntries />
  },
];
